import { render, staticRenderFns } from "./flq.vue?vue&type=template&id=05ba8283&scoped=true&"
import script from "./flq.vue?vue&type=script&lang=js&"
export * from "./flq.vue?vue&type=script&lang=js&"
import style0 from "./flq.vue?vue&type=style&index=0&id=05ba8283&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba8283",
  null
  
)

export default component.exports